import React from 'react';

import { ApiObject, School, Program, Discount } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from 'features/explore/program/tabs/Tabs.module.scss';
import { useMediaQuery } from 'react-responsive';
import { formatNumber } from 'common/utils/conversions';
import { AttributeComponent } from '../../common/components/Overview';

interface CompProps {
  program: ApiObject<Program> | undefined;
  costsRef: React.RefObject<HTMLDivElement>;
  comesFromExplore?: boolean;
}

interface DiscountBannerProps {
  title: string;
  discount_percentage?: number;
  image?: string;
  height?: string;
}

const DiscountBannerComponent = ({
  title,
  discount_percentage,
  image,
  height,
}: DiscountBannerProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className={styles.discountBannerContainer}>
      <Text
        size={isMobile ? 14 : 20}
        weight={600}
        inlineStyle={
          isMobile
            ? {
                color: '#727D9B',
                marginBottom: '4px',
                display: 'flex',
              }
            : { color: '#727D9B', maxWidth: 'inherit', marginBottom: '2px' }
        }
      >
        {title}
      </Text>
      <Text
        size={isMobile ? 18 : 20}
        weight={600}
        inlineStyle={
          isMobile
            ? {
                color: '#297DF2',
                marginBottom: '7px',
                alignItems: 'baseline',
              }
            : { color: '#297DF2', maxWidth: '60%', marginBottom: '33px' }
        }
      >
        {discount_percentage}&nbsp;
        <Text size={isMobile ? 16 : 20} weight={600} inlineStyle={{ color: '#19234F' }}>
          reduction of tuition fee
        </Text>
      </Text>
      <button
        className={`btn btn-primary btn-lg ${styles.discountBannerButton}`}
        onClick={() => window.open('/experts/request-meeting')}
      >
        Contact
      </button>
      {/* <img src={ExpertBannerStar} className={styles.expertBannerStar}></img> */}
      {isMobile ? (
        <img src={image} className={styles.discountBannerIcon}></img>
      ) : (
        <img src={image} className={styles.discountBannerIcon} style={{ height: height }}></img>
      )}
    </div>
  );
};

export const CostsSection = ({ program, costsRef }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div
      className={styles.sectionContainer}
      ref={costsRef}
      id="fee-costs"
      style={{ marginTop: isMobile ? '0px' : '80px' }}
    >
      <div className={styles.sectionTitle}>
        <div className={styles.blueBlock} />
        <h2 className={styles.titleText}>Fee & costs</h2>
      </div>
      <div className={styles.sectionContent} style={{ marginTop: isMobile ? '0px' : '24px' }}>
        {program?.data.fee_cost_description && (
          <Text size={isMobile ? 14 : 16} weight={400}>
            {program?.data.fee_cost_description}
          </Text>
        )}
        <div className={`${styles.sectionAttributes} row row-sm-6 row-lg-4`}>
          {!!(
            (program?.data.application_fee && program.data.application_fee_currency) ||
            (program?.data.school.application_fee && program.data.school.application_fee_currency)
          ) && (
            <AttributeComponent
              attribute={'Application fee'}
              value={
                program?.data.application_fee
                  ? `${program.data.application_fee_currency} ${formatNumber(
                      program.data.application_fee
                    )}`
                  : `${program.data.school.application_fee_currency} ${formatNumber(
                      program.data.school.application_fee
                    )}`
              }
              discount={
                program?.data.discounts.find(
                  (discount: Discount) => discount.kind === 'application_fee'
                )?.description
              }
            />
          )}
          {!!(program?.data.deposit && program?.data.deposit_currency) && (
            <AttributeComponent
              attribute="Deposit"
              value={`${program.data.deposit_currency} ${formatNumber(program.data.deposit)}`}
            />
          )}
          {program?.data.tuition_range && (
            <AttributeComponent attribute="Tuition fee" value={program?.data.tuition_range} />
          )}
          {!!(
            program?.data.school.city.cost_of_living && program?.data.school.city.country.currency
          ) && (
            <AttributeComponent
              attribute="Average living cost"
              value={`${program?.data.school.city.country.currency} ${formatNumber(
                program?.data.school.city.cost_of_living
              )} / Year`}
            />
          )}
        </div>
      </div>
      {/* {program?.data.discounts.find((discount: Discount) => discount.kind === 'tuition_fee') && (
        <DiscountBannerComponent
          title={'Unify Special Scholarship'}
          discount_percentage={
            program?.data.discounts.find((discount: Discount) => discount.kind === 'tuition_fee')
              ?.percentage_value
          }
        />
      )} */}
    </div>
  );
};
